import { render } from "./Web.vue?vue&type=template&id=0f73dc9c"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__